// src/config/brand.js
//
// Single source of truth for the platform brand name. Centralizing this
// avoids repo-wide search-and-replace on every brand iteration and keeps
// the document `<title>` suffix, page-title chains, and any user-facing
// fallback strings in lockstep.
//
// Conventions:
// - Plain string export. Consumers `import { BRAND_NAME } from '@/config/brand'`.
// - The current value is the post-rebrand "ctrl+s" wordmark. Customer-facing
//   copy lives in Strapi (content-* singletypes) and is the primary surface;
//   this constant is for hardcoded fallbacks and SEO `<title>` suffixes.
// - Mirrors the externalLinks.js pattern introduced for HELP_URL.

export const BRAND_NAME = 'ctrl+s';
